import { render, staticRenderFns } from "./ZuDocBoundary.vue?vue&type=template&id=36e592f5&"
import script from "./ZuDocBoundary.vue?vue&type=script&lang=js&"
export * from "./ZuDocBoundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports